<template>
  <div class="el_row">      
    <div class="content">
      <div class="el_col_info">
        <div class="info_item2">
          <div class="logo-wap">
            <a href="http://www.anyidacylinders.com/" target="_self">
              <img src="../assets/logo.png" class="logo" />
            </a>
          </div>          
          <div class="name">天津安易达复合气瓶有限公司</div>
        </div>
        <div class="title">          
          <p>液 化 石 油 气 高 密 度 聚 乙 烯 内 胆</p>
          <p>玻 璃 纤 维 全 缠 绕 气 瓶</p>
          <p>产 品 合 格 证</p>
          <p>Certificate</p>
        </div>
      </div>
      <div class="read-items">
        <div class="read-items__title">
          <p class="item_name l-h">气瓶编号</p>
          <p class="h">Manufacturing serial number</p>
        </div>
        <p class="read-items__con">{{cylinderNo}}</p>
      </div>
      <div class="read-items">
        <div class="read-items__title">
          <p class="item_name l-h">气瓶型号</p>
          <p class="h">Cylinder type</p>
        </div>
        <p class="read-items__con">{{cylinderType}}</p>
      </div>
      <div class="read-items">
        <div class="read-items__title">
          <p class="item_name l-h">充装介质</p>
          <p class="h">Filling medium</p>
        </div>
        <p class="read-items__con">{{gasNameCN}}/{{gasName}}</p>
      </div>
      <div class="read-items">
        <div class="read-items__title">
          <p class="item_name l-h">耐压试验压力</p>
          <p class="h">Test Pressure</p>
        </div>
        <p class="read-items__con">{{testPressureStr}}</p>
      </div>
      <div class="read-items">
        <div class="read-items__title">
          <p class="item_name l-h">公称工作压力</p>
          <p class="h">Working Pressure</p>
        </div>
        <p class="read-items__con">{{workMpaStr}}</p>
      </div>    
        <div class="read-items">
        <div class="read-items__title">
          <p class="item_name l-h">气密性试验压力</p>
          <p class="h">Leakage test pressure</p>
        </div>
        <p class="read-items__con">{{leakageTestPressure}}</p>
      </div> 
        <div class="read-items">
        <div class="read-items__title">
          <p class="item_name l-h">内胆材料</p>
          <p class="h">Liner material</p>
        </div>
        <p class="read-items__con">{{linerMaterial}}</p>
      </div>
        <div class="read-items">
        <div class="read-items__title">
          <p class="item_name l-h">纤维材料</p>
          <p class="h">Fiber material</p>
        </div>
        <p class="read-items__con">{{fiberMaterial}}</p>
      </div>
        <div class="read-items">
        <div class="read-items__title">
          <p class="item_name l-h">树脂材料</p>
          <p class="h">Resin material</p>
        </div>
        <p class="read-items__con">{{resinMaterial}}</p>
      </div>
      <div class="read-items">
        <div class="read-items__title">
          <p class="item_name l-h">气瓶公称容积（L）</p>
          <p class="h">Water Capacity</p>
        </div>
        <p class="read-items__con">{{actualVolume}}</p>
      </div>
      <div class="read-items">
        <div class="read-items__title">
          <p class="item_name l-h">最大充装量（KG）</p>
          <p class="h">Maximum Permissible Filling Weight</p>
        </div>
        <p class="read-items__con">{{mximumFillingWeight}}</p>
      </div>
      <div class="read-items">
        <div class="read-items__title">
          <p class="item_name l-h">公称空瓶重量（含瓶阀）（KG）</p>
          <p class="h">Tare Weight</p>
        </div>
        <p class="read-items__con">{{tare}}</p>
      </div>
      <div class="read-items">
        <div class="read-items__title">
          <p class="item_name l-h">制造年月</p>
          <p class="h">Initial test date</p>
        </div>
        <p class="read-items__con">{{bornOnDate}}</p>
      </div>
      <div class="read-items">
        <div class="read-items__title">
          <p class="item_name l-h">检验周期(年)</p>
          <p class="h">Inspection interval(years)</p>
        </div>
        <p class="read-items__con">{{inspectionInterval}}</p>
      </div>
      <div class="read-items">
        <div class="read-items__title">
          <p class="item_name l-h">设计使用寿命(年)</p>
          <p class="h">Service life(years)</p>
        </div>
        <p class="read-items__con">{{lifetime}}</p>
      </div>
      <div class="read-items">
        <div class="read-items__title">
          <p class="item_name l-h">制造单位代码</p>
          <p class="h">Manufacturer code</p>
        </div>
		<!-- <p class="read-items__con">{{pressureCriteria==1?'061':"AYD"}}</p> -->
        <p class="read-items__con">061</p>
      </div>
      <div class="read-items">
        <div class="read-items__title">
          <p class="item_name l-h">制造许可证编号</p>
          <p class="h">Manufacturing license No</p>
        </div>
        <p class="read-items__con">{{productionLicenceStr}}</p>
      </div>   
        <div class="read-items" style="display: block; white-space: normal;height: auto;">
        <p class="read-items__title" style="text-align: center;line-height: 25px;">本产品的制造符合{{manufactureStandardStr}}和设计图样的要求，经检验合格。</p>
        <p class="read-items__title" style="text-align: center;line-height: 25px;">The manufacturing of this product meets the requirements of {{manufactureStandardStr}} and the design drawing，and it is quelified.</p>
      </div>
      <div class="read-items" style="height:140px;display:flex;padding-top: 6px;">
        <div style="flex:1">
          <p style="font-size:14px;line-height:20px">检验责任师（章）</p>
          <p style="font-size:14px;line-height:20px;margin-bottom: 12px;">Cheeked by</p>
          <img :src="inspectorUrl" width="90" height="" >            
          <p style="font-size:14px;height:20px;line-height: 20px; margin-top: -18px;">{{bornOnDate}}</p>
        </div>
        <div style="flex:1" v-if="pressureCriteria==1?true:false">
          <p style="font-size:14px;height:20px;"></p>
          <p style="font-size:14px;height:20px;margin-bottom:6px;"></p>
          <img :src="TSSignUrl" width="70" height="" >
        </div>
        <div style="flex:1">
          <p style="font-size:14px;line-height:20px">合格证专用章</p>
          <p style="font-size:14px;line-height:20px">Stamp</p>
          <img :src="certificateUrl" width="80" height="" >
        </div>
      </div>           
      <div class="read-items" v-if="pressureCriteria==1">
        <div class="read-items__title">
          <p class="item_name l-h">型式试验证书</p>
          <p class="h">Type test report</p>
        </div>
        <!-- <p v-if="isTypeTestReport == 1" style="color:rgb(0, 0, 238);" @click="downTypeTestReport()" class="read-items__con">点击下载</p>
        <p v-else class="read-items__con">未上传</p> -->
      </div>
      <div class="read-items">
        <div class="read-items__title">
          <p class="item_name l-h">{{pressureCriteria==2 ? '监督检验证书' : '监督检验证书及质量证书'}}</p>
          <p class="h">Inspection-report</p>
        </div>
        <!-- <p v-if="isUpload" style="color:rgb(0, 0, 238);" @click="downLincense" class="read-items__con">点击下载</p>
        <p v-else class="read-items__con">未上传</p> -->
      </div>
      <div class="read-items">
        <div class="read-items__title">
          <p class="item_name l-h">说明书</p>
          <p class="h">Instruction</p>
        </div>
        <!-- <a style="color:rgb(0, 0, 238);" :href="instructionBookUrl" class="read-items__con">点击下载</a> -->
      </div>  
      <div class="read-items" v-if="pressureCriteria==1?true:false">
        <div class="read-items__title">
          <p class="item_name">气瓶档案</p>
        </div>
        <!-- <a style="color:rgb(0, 0, 238);" target="_self" :href='"/ayd_api/101/001/3?cylinderNo="+cylinderNo' class="read-items__con">点击下载</a> -->
      </div>  
	  <!-- <div class="content-2" style="width:100%;" v-if="pressureCriteria==1?true:false"> -->
      <div class="content-2" style="width:100%;">
        <div class="read-items">
          <div class="read-items__title">
            <p class="item_name">气瓶品种</p>
          </div>
          <p class="read-items__con">{{cylinderVarieties}}</p>
        </div>
        <div class="read-items">
          <div class="read-items__title">
            <p class="item_name">瓶体设计壁厚</p>
          </div>
          <p class="read-items__con">≥{{designThickness}}mm</p>
        </div>
        <div class="read-items">
          <div class="read-items__title">
            <p class="item_name">制造单位</p>
          </div>
          <p class="read-items__con">{{cylinderManufacturerName}}</p>
        </div>
        <div class="read-items">
          <div class="read-items__title">
            <p class="item_name">出厂年月</p>
          </div>
          <p class="read-items__con">{{checkoutDate}}</p>
        </div>
        <div class="read-items">
          <div class="read-items__title">
            <p class="item_name">气瓶统一编号</p>
          </div>
          <p class="read-items__con">{{uniteNo}}</p>
        </div>
        <div class="read-items">
          <div class="read-items__title">
            <p class="item_name">阀门生产厂家</p>
          </div>
          <p class="read-items__con">{{valveName}}</p>
        </div>
          <div class="read-items">
          <div class="read-items__title">
            <p class="item_name">监督检验证书编号</p>
          </div>
          <p class="read-items__con">{{inspectionCertificateNo}}</p>
        </div>
          <div class="read-items">
          <div class="read-items__title">
            <p class="item_name">产品标准号</p>
          </div>
          <p class="read-items__con">{{productStandardStr}}</p>
        </div>
        <div class="read-items">
          <div class="read-items__title">
            <p class="item_name">气瓶购买使用单位</p>
          </div>
          <p class="read-items__con">{{customerName}}</p>
        </div>          
      </div>
      <div class="detail-flag__img__wapper" v-show="pressureCriteria==1">
        <div class="detail-flag__img" :class="cylinderType == 'FYSP-G-18-A' ? 'bg-color__18': 'bg-color'">
          <div id="qrcode" class="qrcode" ref="qrcode"></div>
          <div class="detail-flag__img__text">
            <p style="letter-spacing: -0.2px;"><span>T/CATSI 02005</span>&nbsp;<span>TS2210Q03</span></p>
            <p><span>{{actualVolume}}L</span>&nbsp;&nbsp;<span>FW{{mximumFillingWeight}}KG</span>&nbsp;&nbsp;<span>LPG</span>&nbsp;&nbsp;<span :class="cylinderType == 'FYSP-G-18-A' ? 'f-c-18' : 'f-c-bule'">{{bornOnDate}}</span></p>
            <p><span>{{tare}}KG</span>&nbsp;<span>2.1MPa</span>&nbsp;<span>Pf3.2MPa</span>&nbsp;<span :class="cylinderType == 'FYSP-G-18-A' ? 'f-c-18' : 'f-c-bule'">{{cylinderNo}}</span></p>
          </div>
          <div class="detail-flag__img__footer">
            <div class="footer-logo">
              <img src="../assets/logo.png" style="display: block; width: 100%;" />
            </div>
            <p class="">天津安易达复合气瓶有限公司</p>
          </div>
        </div>
      </div>					
    </div>
    <div class="foot">
      <a href="http://www.anyidacylinders.com/">
        <span>天津安易达复合气瓶有限公司</span>
      </a>
      版权所有
      <a href="http://beian.miit.gov.cn">
        <span>津ICP备19005314号-1</span>
      </a>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
export default {
  data() {
    return {
      cylinderNo:"",
      cylinderType:"",
      gasName:"",
      gasNameCN:"",
      actualVolume:"",
      productStandard: "",
      productStandardStr:"",
      lifetime:"",
      productionLicenceStr:"",
      pressureCriteria:"",
      pressureCriteriaStr:"",
      workMpaStr:"",
      testPressureStr:"", 
      leakageTestPressure:"",
      linerMaterial:"",
      fiberMaterial:"",
      resinMaterial:"",
      inspectionInterval:"", 
      cylinderVarieties:"",
      designThickness:"",
      checkoutDate:"",
      uniteNo:"",
      valveName:"",
      manufactureStandardStr:"",
      customerName:"",
      emptyWeight:"",
      tare:"",
      cylinderManufacturerName:"",
      cylinderManufacturerNo:"",      
      mximumFillingWeight:"",
      isUpload:"",
      bornOnDate:"",
      dialogOption: {},
      isModalVisible: false,
      inspectorUrl: "",
      TSSignUrl: "",
      certificateUrl: "",
      instructionBookUrl:"",
      inspectionCertificateNo:"",
      isTypeTestReport: "",
      ctime: "",
      version1Time: new Date("2021-01-24 08:59:28"),
    };
  },
  created() {
    this.cylinderNo = this.$route.query.epc;
    this.getCylinderInfo();
  },
  // mounted(){
  //   this.createQrCode();
  // },
  methods: {
    getCylinderInfo() {
      var url_getInfo = "/ayd_api/100/004/3?cylinderNo=" + this.cylinderNo;
      this.axios
        .get(url_getInfo)
        .then(res => {
          if (res.data && res.data.code == 0) {
            this.cylinderNo = res.data.cylinderNo;
            this.pressureCriteria = res.data.pressureCriteria;
            this.productStandard = res.data.productStandard;
            this.ctime = new Date(res.data.cTime);
            // version 1.0
            if (this.ctime <= this.version1Time // 版本v1.0生效时间: 2021-01-24 08:59:28之前  
              && this.productStandard == 4 // 产品标准: T/CATSI 02005 标准
              && this.pressureCriteria == 1 // 压力标准: 国内标准
            ) {
              this.$router.push({
                path: "/v1",
                query: {
                  cylinderNo: this.cylinderNo,
                }
              })
            // version 2.0    // 版本v2.0生效条件: v1.0之外所有气瓶
            } else {
              this.$router.push({
                path: "/v2",
                query: {
                  cylinderNo: this.cylinderNo,
                }
              })
            }
          } else {
            alert(res.data.message);
          }
        })
        .catch(function(errorMessage) {
          alert(errorMessage);
        });
    },
    // downLincense(){
    //   window.location.href = "/ayd_api/201/005/3?cylinderNo="+this.cylinderNo+"&timestamp="+ new Date().getTime()
    // },
    // downTypeTestReport(){
    //   window.location.href = "/ayd_api/201/006/3?cylinderNo=" + this.cylinderNo + "&timestamp=" + new Date().getTime()
    // },
    // createQrCode(){
    //   new QRCode(this.$refs.qrcode, {
    //     text: "http://aydqp.cn/"+ this.cylinderNo +"LPG",
    //     width: 80,
    //     height: 80,
    //     colorDark: "#000000",
    //     colorLight: "transparent",
    //   });
      
    //   var dom = document.getElementById("qrcode")
    //   dom.children[1].style.width = "100%"
      
    // }
  }
};
</script>

<style scoped>
body {
  overflow-x: hidden;
}
.content{
  margin-top:40px;
}
.content-2>div{
  width: 100%;
}
.el_row {
  width: 50%;
  height: 100%;
  margin: auto;
}
.logo-wap{
  position: absolute;
  width: 11vw;
}
@media (max-width: 460px){
  .logo-wap{
    position: static;
    width: 90px;
  }
}
.name{
  line-height: 40px;
  text-align: center;
  color: #000000;
}
.title{
  width: 100%;
  line-height: 30px;
  text-align: center;
  margin: 0 auto;
  font-size:20px;
  color: #000000;
}
@media (max-width: 700px) {
  .el_row {
    flex: 1;
    width: 100%;
    height: 100%;
  }
}

.el-col_image {
  width: 40%;
  float: left;
}

.el_col_info {
  width: 100%;
}
.content {
  display: flex;
  flex-direction: column;
  border: 1px solid #bbbbbb;
  background: #fff;
  align-items: center;
}

.info_item1 {
  color: #1094cc;
  font-size: 20px;
}

.info_item2 {
  position: relative;
  font-size: 22px;
  margin-top: 12px;
}
.logo {
  width: 100%;
}
.number {
  text-align: center;
  line-height: 55px;
}

.info_item3 {
  text-align: right;
  margin: 15px;
  color: #3f51b5;
  font-size: 14px;
}

.read-items {
  position: relative;
  display: flex;
  justify-content: space-between;  
  width: 100%;
  height: 50px;
  line-height: 50px;
  white-space: nowrap;
  font-size: 16px;
  padding: 0px 10px;
}
.read-items:not(:last-child):after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  background: #d9d9d9;
  margin-left: 12px;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
}

.read-items__title {
  text-align: left;
  color: rgba(16, 16, 16, 0.8);
}

.read-items__con {
  text-align: right;
  color: rgba(16, 16, 16, 0.8);
}

.icon_img {
  height: 140px;
}
.foot {
  width: 100%;
  height: 25px;
  line-height: 25px;
  color: #000000;
  font-size: 12px;
  text-align: center;
}
.l-h{
  line-height: 40px;
}
.h{
  line-height: 0px
}
.detail-flag__img__wapper{
  background: #fff;
  padding: 10px 0;
  width: 366px;
}
.detail-flag__img{
  width: 100%;  
  padding: 8px;
  margin: 0 auto;
  color: #000;
  
}
.bg-color{
  background: #00e2f9;
}
.bg-color__18{
  background: #f7b033;
}
.detail-flag__img__text p{
  line-height: 40px;
  text-align: left;
  font-family: "calibrii";
  font-size: 25px;
  letter-spacing: -2px;  
  transform: scale(1,1.8);
}
.qrcode{
  float: right;
}
.detail-flag__img__footer{
  display: flex;
  align-items: center;
  margin-top: 1px;
}
.detail-flag__img__footer p{
  font-family:"lishu1";
  font-size: 24px;
  letter-spacing: -4px;
  transform: scaleY(2);
}
.footer-logo{
  width: 90px;
  height: 31px;
}
.f-c-bule{
  color: #0000ff;
}
.f-c-18 {
  color: #660066;
}
@media (max-width: 700px) {
  .detail-flag__img__wapper{
    width: 95%;
  }
  .detail-flag__img__text p{
    line-height: 11vw;
    font-size: 6.3vw;
  }
  .detail-flag__img__footer p{
    font-size: 5.8vw;
  }
  .detail-flag__img__footer{
    line-height: 26px;
  }
  .footer-logo{
    width: 26vw;
  }
  .qrcode{
    width: 22vw;
  }  
}
@font-face{
  font-family: "calibrii";
  src: url("../assets/font/calibri.ttf");
}
@font-face{
  font-family: "lishu1";
  src: url("../assets/font/lishu.ttf");
}
</style>



// WEBPACK FOOTER //
// src/components/cylinderInfo.vue